export function formatCompactNumber(value: number) {
  const formatter = Intl.NumberFormat('en', { notation: 'compact' });

  return formatter.format(value);
}

export function formatCommaNumber(value: number) {
  const formatter = Intl.NumberFormat('ko');

  return formatter.format(value);
}
